import { DEFAULT_LANGUAGE } from ".";
export var Languages;
(function (Languages) {
    Languages["EN"] = "en";
    Languages["ES"] = "es";
})(Languages || (Languages = {}));
const languagesList = Object.values(Languages);
export const ensureValidLanguage = (lang) => {
    return lang && languagesList.includes(lang)
        ? lang
        : DEFAULT_LANGUAGE;
};
export const getLocaleFromPath = (path) => {
    if (path.startsWith("/en")) {
        return Languages.EN;
    }
    if (path.startsWith("/es")) {
        return Languages.ES;
    }
    return DEFAULT_LANGUAGE;
};
export const LanguagesInfo = {
    [Languages.EN]: {
        name: "English",
        abbreviation: Languages.EN,
        flagImageUrl: "/images/flags/us.svg",
        flagCountry: "US",
        pathnamePrefix: "/en",
    },
    [Languages.ES]: {
        name: "Español",
        abbreviation: Languages.ES,
        flagImageUrl: "/images/flags/mx.svg",
        flagCountry: "Mexico",
        pathnamePrefix: "/es",
    },
};
export const languageMap = {
    idioma: Languages.ES,
    en: Languages.EN,
    es: Languages.ES,
};
